module.exports = __webpack_public_path__ + "static/media/Bogota.af215cb3.png";